import { Component, Input, OnInit } from "@angular/core";
import { TranslationModuleEnum } from "src/app/utils/translation-modules.enum";

@Component({
  selector: "app-no-data",
  templateUrl: "./no-data.component.html",
  styleUrls: ["./no-data.component.scss"],
})
export class NoDataComponent implements OnInit {
  translationModulesEnum = TranslationModuleEnum;
  // @Input() msg: string = "Hmm.. looks like you don't have any Services";

  @Input() _msgTranslationKey: string = "";
  @Input() _msgTranslationKey2: string = "";
  @Input() _selectedTranslatioModuleEnum: number;
  @Input() _selectedTranslatioModuleEnum2: number;
  @Input() image: string = "assets/img/no-data.svg";

  _msg: string = "";
  _msg2: string = "";
  _isFiltring: boolean = false;

  @Input() set selectedTranslationModuleEnum(mod: number) {
    this._selectedTranslatioModuleEnum2 = mod;
    this._selectedTranslatioModuleEnum = this._isFiltring
      ? TranslationModuleEnum.shared
      : mod;
  }

  @Input() set msg(_msg: string) {
    this._msg = this._isFiltring ? "shared.noDataMsgFilter" : _msg;
    this._msg2 = _msg;
  }

  @Input() set msgTranslationKey(key: string) {
    this._msgTranslationKey = this._isFiltring ? "shared.noDataMsgFilter" : key;
    this._msgTranslationKey2 = key;
  }

  @Input() set isFiltering(_filtring: boolean) {
    this._isFiltring = _filtring;

    this._msg = this._isFiltring ? "shared.noDataMsgFilter" : this._msg2;

    this._selectedTranslatioModuleEnum = this._isFiltring
      ? TranslationModuleEnum.shared
      : this._selectedTranslatioModuleEnum2;

    this._msgTranslationKey = this._isFiltring
      ? "shared.noDataMsgFilter"
      : this._msgTranslationKey2;
  }
  constructor() {}

  ngOnInit(): void {}
}
